const superAdminTheme = {
  '--theme-primary': '#33658a',
  '--theme-secondary': '#FF8861',
  '--theme-text-base': '',
  '--theme-primary-50': '#468dbf',
  '--theme-textSecondary': '#828c99',
  '--theme-textPrimary': '#204159',
  '--theme-primary-light': '#ffb2b7',
  '--theme-sidebar-bg-from': '#ffeda0',
  '--theme-sidebar-bg-to': '#e5a359',
  '--theme-sidebar-text': '#ffffea',
  '--theme-sidebar-select-text': '#33658a',
  '--theme-ring-color': 'rgba(51, 101, 138,0.1)',
  '--theme-sidebar-selected-bg': 'rgba(255, 255, 234,0.3)',
  '--theme-error': '#ff4d4f',

};
export default superAdminTheme;
